<template>
  <div class="w-full flex justify-end">
    <button
      class="rounded-md bg-primary/80 hover:bg-primary flex items-center hover:scale-[1.02] px-1.5 ltr:font-sans tracking-wide text-white text-sm pb-[1px] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
      @click.stop.prevent="toggle()"
    >
      {{ $t(attrs.text) }}
    </button>
    <Teleport v-if="modal" to="body">
      <div
        class="modal__overlay z-10 fixed top-0 start-0 p-4 md:p-0 w-screen h-screen flex justify-center items-center bg-brand-black-body/30"
        @click.stop.prevent="toggle()"
      >
        <div
          class="modal__wrapper z-50 absolute w-full h-full flex justify-center items-center"
          @click.stop.prevent="toggle()"
        >
          <div
            :style="[aspectRatio]"
            :class="[modalWidth]"
            class="bg-white rounded shadow-lg"
            @click.stop=""
          >
            <div
              class="modal__header flex justify-between items-center h-12 px-2 md:px-4 border-b border-brand-gray-300"
            >
              <HeaderTypo as="h3">
                {{ $t(attrs.text) }}
              </HeaderTypo>
              <button class="hover:scale-[1.02]" @click.stop.prevent="toggle()">
                <faTimes class="w-4 fill-brand-black-secondary" />
              </button>
            </div>
            <div class="modal__body p-2 md:p-4 max-h-full overflow-y-auto">
              <component :is="modalContent"></component>
            </div>
            <div class="modal__footer p-2 md:p-4 flex justify-end items-center gap-x-4"></div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { useToggle } from '@vueuse/core'
import { useAttrs, watch, computed } from 'vue'
import HeaderTypo from '@/components/typography/h1.vue'
import faTimes from '@/assets/icons/faTimes.svg?component'

import SubscriptionServicesDetails from '@/components/Form/PopupContent/SubscriptionServicesDetails.vue'

const attrs = useAttrs()
const [modal, toggle] = useToggle()

const aspectRatio = computed(() => ({
  aspectRatio: attrs.aspect_ratio || '4/3'
}))

const modalWidth = computed(() => 'w-[97%] md:w-4/5')

const modalContent = computed(() => {
  const { builder_func } = attrs
  switch (builder_func) {
    case 'TheServicesToSubscribeDetails':
      return SubscriptionServicesDetails

    default:
      return ''
  }
})

watch(modal, (newValue) => {
  document.body.style.overflow = newValue ? 'hidden' : 'inherit'
})
</script>

<style lang="scss" scoped></style>
